export enum ProfileActionType {
    SET_PROFILE = 'SET_PROFILE',
    RELOAD_PROFILE = 'RELOAD_PROFILE'
}